/**
 * Whether `target` is an element that takes typed text: an input, a textarea
 * or a contentEditable element. A keyboard shortcut leaves a key alone while
 * such an element has focus, so the key reaches the text the user types.
 */
export function isTextEntryElement(
    target: EventTarget | null | undefined
): boolean {
    if (!(target instanceof HTMLElement)) {
        return false;
    }
    return (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable === true
    );
}

/**
 * Whether a dialog is open. A keyboard shortcut also leaves its key alone
 * then, so it does not act on the view behind the dialog.
 */
export function isDialogOpen(): boolean {
    return (
        document.querySelector('[role="dialog"], [role="alertdialog"]') !== null
    );
}
